/**
 * Normalize shop domain to consistent format: {store}.myshopify.com
 * Used everywhere to ensure exact match between OAuth save and session fetch.
 */
export function normalizeShopDomain(shop: string): string {
  const cleaned = (shop || '').replace(/^https?:\/\//, '').replace(/\/$/, '').trim()
  if (!cleaned) return ''
  return cleaned.endsWith('.myshopify.com') ? cleaned : `${cleaned}.myshopify.com`
}
